// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f77c91fe","351":"64d5a271"}[chunkId] + ".chunk.js";
};